export const CONTENT_TYPES_LABELS = {
  articleheader: "Article",
  interactivevideolink: "Interactive video",
  textset: "Text set",
  externallink: "Worksheet",
};

export const DISABLED_ASSIGNMENT_ACTIONS_TEXT_SET_TYPES: {
  [key: string]: string;
} = {
  Unit: "Unit",
  Row: "Row",
  Collection: "Collection",
  Module: "Module",
  Topics: "Topics",
};

export enum ContentTypesEnum {
  externallink = "externallink",
  articleheader = "articleheader",
  interactivevideolink = "interactivevideolink",
  textset = "textset",
}

export const CONTENT_CARD_DATE_TIME_FORMAT = "MMM DD, YYYY";
export const CONTENT_CARD_READ_UNTIL_DATE_TIME_FORMAT = "MMM DD";

export const READING_SKILLS_MAP: { [key: string]: unknown } = {
  "essentials-reading-skills-what-the-text-says": "What the text says",
  "essentials-reading-skills-main-idea":
    "Main idea, key details & summarization",
  "essentials-reading-skills-key-details":
    "Main idea, key details & summarization",
  "essentials-reading-skills-summarization":
    "Main idea, key details & summarization",
  "essentials-reading-skills-connecting-people-events-ideas":
    "Connecting people, events & ideas",
  "essentials-reading-skills-word-meaning-choice": "Word meaning & choice",
  "essentials-reading-skills-text-structure": "Text structure",
  "essentials-reading-skills-point-of-view-purpose": "Point of view & purpose",
  "essentials-reading-skills-interpret-multimedia": "Interpret multimedia",
  "essentials-reading-skills-arguments-claims": "Arguments & claims",
  "essentials-reading-skills-theme": "Theme",
};

export const ARTICLE_STORY_MAP: { [key: string]: string } = {
  information: "Information",
  editorial: "Editorial",
  news: "News",
  opinion: "Opinion articles",
  procon: "Pro/Con articles",
  explainer: "Explainers and overviews",
  speeches: "Speeches",
  primarysource: "Primary sources",
  biography: "Biography",
  fiction: "Fiction",
  poetry: "Poetry",
};
